(function() {
    'use strict';
    function MwLocationExpansionPanelController($scope, $element, $translate, $mdDialog, MapService, $rootScope) {
        var message,
            contentElement = $element.find('md-card-content'),
            expandIcon = $element.find('md-icon.expand-icon'),
            searchIcon = $element.find('md-icon.search-icon'),
            collapseIcon = $element.find('md-icon.collapse-icon');

        this.searchText = '';
        this.selectedItem = null;
        this.itemCountMessage = 'icm-search__map-filter--result-count';
        this.MapService = MapService;
        this.$mdDialog = $mdDialog;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.itemCount = 0;
        this.active = false;
        this.getMapTabLabel = function getMapTabLabel() {
            return this.$translate.instant('icm-search__map-filter--label');
        }.bind(this);

        this.getListTabLabel = function getListTabLabel() {
            return this.$translate.instant('icm-search__location-filter--label');
        }.bind(this);

        this.getFindBoxPlaceholderText = function getFindBoxPlaceholderText() {
            return this.$translate.instant(this.findBoxPlaceholder);
        }.bind(this);

        this.getNotFindMessage = function getNotFindMessage() {
            return this.$translate.instant('icm-search__expansion-panel--not-found-label', {searchText: this.searchText});
        }.bind(this);

        this.getZeroResultsButtonText = function getZeroResultsButtonText() {
            return this.$translate.instant('icm-search__map-filter--zero-results-button');
        }.bind(this);

        this.toggle = function toggle() {
            this.active = true;
            $element.toggleClass('active');
            contentElement.toggle();
            expandIcon.toggle();
            collapseIcon.toggle();
            //See GYDA-37005 for why this event is here
            window.dispatchEvent(new Event('resize'));
        };

        this.clickedClear = function clickedClear(e) {
            e.stopPropagation();

            this.searchText = '';
            this.selectedItem = null;
            this.MapService.setInteractionState(this.MapService.BLANK);
            this.$rootScope.$broadcast('clearLocationFilter');
        };

        this.optionSelected = function optionSelected(item) {
            if (item) {
                return this.isSelected({option: item});
            }
            return false;
        };

        this.selectedItemChange = function selectedItemChange(item) {
            if(item) {
                if (!this.optionSelected(item)) {
                    this.searchText = '';
                }
                this.selectionChanged({selectedItem: item});
            }
        };

        this.onFocus = function onFocus() {
            searchIcon.addClass('active');
        };

        this.onBlur = function onBlur() {
            if (this.searchText.length === 0) {
                searchIcon.removeClass('active');
            }
        };

        this.$onChanges = function $onChanges(changes){
            if(changes.mapSearchText){
                this.mapSearchText = changes.mapSearchText.currentValue;
            }
        };

        this.mapViewClicked = function(bool) {
            this.mapView({bool: bool});
        };

        this.$rootScope.$on('updateTotalCount', function(event, arg) {
            this.itemCount = arg.itemCount;

            message = (this.itemCount > 1 || this.itemCount === 0) ? 'icm-search__map-filter--results-count' : 'icm-search__map-filter--result-count';
            if(!this.itemCount){
                this.itemCount = 0;
            }
            else if (this.itemCount > 499) {
                this.itemCount = '+500';
            }

            this.itemCountMessage = this.getItemCountMessage(message);
            this.MapService.setInteractionState(this.MapService.RESULTS_COUNT);
        }.bind(this));

        this.getItemCountMessage = function getItemCountMessage(message) {
            return this.$translate.instant(message, {itemCount: '<b>' + this.itemCount + '</b>'}, null, null, null);
        };

        this.updateSearchClicked = function() {
            this.mapActive = true;
            this.MapService.setInteractionState(this.MapService.LOADING_TEXT);
            this.MapService.triggerSearch();
        };

        this.mapNotSupportedDialog = function mapNotSupportedDialog(ev) {
            var title = 'icm-search__map-filter--not-support-dialog-title',
                body = 'icm-search__map-filter--not-support-dialog-body',
                okButton = 'OK';

            this.$mdDialog.show(
                this.$mdDialog.mwAlert()
                    .title(this.$translate.instant(title))
                    .textContent(this.$translate.instant(body))
                    .ok(this.$translate.instant(okButton))
                    .targetEvent(ev)
            );
        };

        this.zeroResultsDialog = function zeroResultsDialog(ev) {
            var title = 'icm-search__map-filter--zero-results-dialog-title',
                body = '<div class="mw-dialog__text-content">' + this.$translate.instant('icm-search__map-filter--zero-results-dialog-body-1') + '<br/><br/>' + this.$translate.instant('icm-search__map-filter--zero-results-dialog-body-2') + '<br/><br/>',
                countryListDisplay = '<div class="double-list"><ul><li>' + this.countryList.join('</li><li>') + '</li></div></div>',
                okButton = 'OK';
            this.$mdDialog.show(
                this.$mdDialog.mwMiniModal()
                    .class('zero-results-modal')
                    .title(this.$translate.instant(title))
                    .htmlContent(body + countryListDisplay)
                    .ok(this.$translate.instant(okButton))
                    .wide(true)
                    .targetEvent(ev)
            );
        };

        this.syncUpState = function() {
            this.interactionState = this.MapService.getInteractionState();
            try {
                this.$rootScope.$digest();
            }
            catch(err) {} // jshint ignore:line
        };

        this.syncUpState();
        this.MapService.registerUpdateInteractState(this.syncUpState.bind(this));
        this.MapService.setInteractionState(this.MapService.HELPER_TEXT);
    }

    angular
        .module('MW.ContactManager.MwLocationExpansionPanel', [
            'ngMaterial',
            'mwAppComponents',
            'MW.Framework.CoreUserService',
            'MW.Framework.ICMUserService',
            'MW.Influencers.MapService'
        ])
        .directive('tabWatcher', [
            'CoreUserService',
            'ICMUserService',
            'MapService',
            '$translate',
            '$mdDialog',
            '$rootScope',
        function(
            CoreUserService,
            ICMUserService,
            MapService,
            $translate,
            $mdDialog,
            $rootScope
            ) {
            return {
                require: ['mdTabs'],
                restrict: 'A',
                link: function(scope, el, attrs, controllers) {
                    var _this = this;
                    this.CoreUserService = CoreUserService;
                    this.ICMUserService = ICMUserService;
                    this.MapService = MapService;
                    this.$translate = $translate;
                    this.$mdDialog = $mdDialog;
                    this.titleText = 'icm-search__location-mini-mod--reset-title';
                    this.mapBodyText = 'icm-search__location-mini-mod--reset-list-desc';
                    this.listBodyText = 'icm-search__location-mini-mod--reset-map-desc';
                    this.dontShowAgainText = 'icm-search__location-mini-mod--dont-show-again';
                    this.previousTab = 0;
                    this.newTab = null;
                    this.dontShowAgainChecked = false;
                    this.showTabSwitchModal = attrs.showTabSwitchModal || true;
                    this.changesHappened = function onChanges(){
                        //Changes on the variable passed in don't propagate, for some reason
                        //Thus, we're using lexical scoping to save us from the headache of finding the real issue.
                        _this.dontShowAgainChecked = !_this.dontShowAgainChecked;
                    };

                    var mdTabsCtrl = controllers[0],
                        mdTabsCtrlSelect = mdTabsCtrl.select;

                    this.getAppSettings = function getAppSettings(){
                        return new Promise((resolve, reject)=>{
                            this.CoreUserService.getCurrent(true)
                            .then((currentUser)=>{
                                resolve(this.ICMUserService.getAppSettings('contacts', currentUser._id));
                            })
                            .catch(err => {
                                reject(err);
                            });
                        });
                    };

                    this.showTabSwitchDialog = function showTabSwitchDialog() {
                        var bodyText = !!this.previousTab ? this.mapBodyText : this.listBodyText;
                        this.$mdDialog.show(
                            this.$mdDialog.mwMiniModal({
                                locals: {
                                    title: this.$translate.instant(this.titleText),
                                    body: this.$translate.instant(bodyText),
                                    dontShowAgainText: this.$translate.instant(this.dontShowAgainText),
                                    changesHappened: this.changesHappened
                                },
                                templateUrl: 'icm-web/views/search_location_mini_modal',
                                controllerAs: '$ctrl'
                            })
                        ).then(
                            function okHandler() {
                                mdTabsCtrlSelect(this.newTab);
                                $rootScope.$broadcast('clearLocationFilter');
                                this.previousTab = this.newTab;
                                if(_this.dontShowAgainChecked){
                                    this.getAppSettings().then(settings => {
                                        let newSettings = Object.assign(settings, {showLocationSwitchTabModal: false});
                                        this.ICMUserService.setAppSettings('contacts', newSettings);
                                    });
                                }
                            }.bind(this),
                            function cancelHandler() {
                                //'You selected cancel'
                            }
                        ).catch(function () {});
                    };

                    this.switchTabs = function switchTabs(tab){
                        mdTabsCtrlSelect(tab);
                        $rootScope.$broadcast('clearLocationFilter');
                        this.previousTab = tab;
                    };

                    this.shouldShowModal = function shouldShowModal(settings) {
                        var showLocationSwitchTabModal = settings.showLocationSwitchTabModal === undefined ? true : settings.showLocationSwitchTabModal,
                            mapOrLocationFilterIsDirty = this.MapService.isMapDirty() || this.MapService.isLocationFilterDirty();

                        if (mapOrLocationFilterIsDirty && showLocationSwitchTabModal && this.previousTab !== this.newTab) {
                            // if map isn't supported (ie10) don't show when switching from map to list
                            return (this.MapService.isMapSupported || (!this.MapService.isMapSupported && this.previousTab === 1 && this.newTab === 0));
                        } else {
                            return false;
                        }
                    }.bind(this);

                    mdTabsCtrl.select = function(newTab) {
                        this.newTab = newTab;
                        this.getAppSettings().then(settings => {
                            if (this.shouldShowModal(settings)) {
                                this.showTabSwitchDialog();
                            } else {
                                this.switchTabs(newTab);
                            }
                        });

                    }.bind(this);
                }
            };
        }])
        .component('mwLocationExpansionPanel', {
            bindings: {
                autoSuggest: '&',
                currentOptions: '<',
                findBoxPlaceholder: '@',
                hideAutocomplete: '<',
                infoTip: '<',
                updateButtonText: '<',
                isSelected: '&',
                mapDataPoints: '<',
                seeAll: '&',
                selectionChanged: '&',
                selectionCount: '&',
                title: '@',
                viewport: '<',
                mapView: '&',
                mapSearchText: '<',
                mapFilterSelected: '<',
                showTabSwitchModal: '<',
                mapActive: '=',
                startingBounds: '=',
                countryList: '='
            },
            controller: ['$scope', '$element', '$translate', '$mdDialog', 'MapService', '$rootScope', MwLocationExpansionPanelController],
            template: `
                <md-card>
                    <md-card-title ng-click="$ctrl.toggle()">
                        <md-card-title-text layout="row">
                            <span flex>
                                <span class="panel-title">{{$ctrl.title}}</span>
                                <mw-infotip text-content="{{$ctrl.infoTip}}"></mw-infotip>
                                <span ng-if="$ctrl.selectionCount()" class="panel-title" ng-hide="true">({{$ctrl.selectionCount()}})</span>
                                <span class="clear-selection pull-right" ng-if="$ctrl.selectionCount() || $ctrl.mapFilterSelected" ng-click="$ctrl.clickedClear($event)" translate>icm-search__filter-clear</span>
                            </span>
                            <md-icon class="expand-icon" md-svg-icon="navigation:ic_expand_more_24px"></md-icon>
                            <md-icon class="collapse-icon" md-svg-icon="navigation:ic_expand_less_24px"></md-icon>
                        </md-card-title-text>
                    </md-card-title>
                    <md-card-content>
                        <md-tabs tab-watcher show-tab-switch-modal="{{$ctrl.showTabSwitchModal}}" class="location-tabs" md-dynamic-height md-stretch-tabs="always" md-selected="selected">
                            <md-tab label="{{$ctrl.getMapTabLabel()}}" ng-class="{'with-border': $ctrl.hideAutocomplete}">
                                <md-content ng-if="$ctrl.MapService.isMapSupported && $ctrl.active" ng-class="{'with-border': $ctrl.hideAutocomplete}" class="location-tab-content">
                                    <div class="map-search-placeholder"></div>
                                    <mw-map
                                        starting-bounds="$ctrl.startingBounds"
                                        map-search-text="$ctrl.mapSearchText"
                                        map-data-points="$ctrl.mapDataPoints"
                                        viewport="$ctrl.viewport"
                                        update-search-clicked="$ctrl.updateSearchClicked()"
                                        />
                                </md-content>
                                <md-content ng-if="!$ctrl.MapService.isMapSupported" class="location-tab-content">
                                    <div class="map-not-supported" style="background-image: url('https://assets.meltwater.io/icm-web-assets/static/img/search/map-disabled.png');">
                                        <md-button class="md-primary mw-button map-not-supported-button" ng-click="$ctrl.mapNotSupportedDialog($event)">
                                            <span translate="icm-search__map-filter--map-not-supported"></span>
                                        </md-button>
                                    </div>
                                </md-content>
                                <md-toolbar ng-if="$ctrl.MapService.isMapSupported" layout="row" layout-align="start center">
                                    <span ng-if="$ctrl.interactionState===$ctrl.MapService.HELPER_TEXT" class="helper-text" translate="icm-search__map-filter--helper-text"></span>
                                    <span ng-if="$ctrl.interactionState===$ctrl.MapService.LOADING_TEXT" class="results-loading-text" translate="icm-search__map-filter--results-loading"></span>
                                    <span ng-if="$ctrl.interactionState===$ctrl.MapService.RESULTS_COUNT" class="results-count">
                                        <span ng-bind-html="$ctrl.itemCountMessage"></span>
                                        <span ng-if="$ctrl.itemCount === 0" class="zero-results-button" ng-click="$ctrl.zeroResultsDialog()" aria-label="Why?">{{$ctrl.getZeroResultsButtonText()}}</span>
                                    </span>
                                    <md-button ng-if="$ctrl.interactionState===$ctrl.MapService.SHOW_BUTTON" class="md-primary update-bar mw-button md-ink-ripple" ng-click="$ctrl.updateSearchClicked()" aria-label="Update contact results">
                                        <span class="update-bar" translate="{{$ctrl.updateButtonText}}"></span>
                                    </md-button>
                                </md-toolbar>
                            </md-tab>
                            <md-tab label="{{$ctrl.getListTabLabel()}}">
                                <md-content ng-class="{'with-border': $ctrl.hideAutocomplete}">
                                    <div class="find-box" ng-hide="$ctrl.hideAutocomplete">
                                        <md-icon class="search-icon" md-svg-icon="action:ic_search_24px"></md-icon>
                                        <md-autocomplete
                                                md-no-cache="true"
                                                md-theme="expansion-panel"
                                                md-min-length="2"
                                                md-delay="50"
                                                md-select-on-match="true"
                                                md-match-case-insensitive="true"
                                                placeholder="{{$ctrl.getFindBoxPlaceholderText()}}"
                                                md-search-text="$ctrl.searchText"
                                                md-selected-item="$ctrl.selectedItem"
                                                md-selected-item-change="$ctrl.selectedItemChange(item)"
                                                ng-focus="$ctrl.onFocus()"
                                                ng-blur="$ctrl.onBlur()"
                                                md-items="item in $ctrl.autoSuggest({searchText: $ctrl.searchText})"
                                                md-item-text="item.display">
                                            <md-item-template>
                                                <span md-highlight-text="$ctrl.searchText" md-highlight-flags="i">{{item.display}}</span>
                                            </md-item-template>
                                            <md-not-found>
                                                <span>{{$ctrl.getNotFindMessage()}}</span>
                                            </md-not-found>
                                        </md-autocomplete>
                                    </div>
                                    <div class="see-all" ng-click="$ctrl.seeAll()">
                                        <md-icon md-svg-icon="action:ic_list_24px"></md-icon>
                                        <span translate>icm-search__filter--see-all</span>
                                    </div>
                                </md-content>
                            </md-tab>
                        </md-tabs>
                    <md-card-content>
                </md-card>
            `
        });
}());
